<template lang="html">
  <div class="flex flex-col h-full">
      <h2 class="font-medium text-lg"> Shooting plan </h2>
    <div class="pt-2" v-if="!isGuest">
      <select name="shootingplans" class="form-input" v-model="selected_plan"
              v-on:change="changedShootingPlan()">
        <option value="null" selected>No shooting plan</option>
        <option :value="-1" @click="showUploadFolderModal = true" v-if="!isGuest">Upload a plan</option>
        <option :value="shooting_plan" v-for="shooting_plan in shooting_plans">{{ shooting_plan.title }}</option>
      </select>
    </div>
    <div class="overflow-y-scroll bg-gray-50 dark:bg-gray-800 rounded-lg shadow-inner mt-2 flex-grow" border-b-4 border-gray-100>
      <div v-if="selected_plan" class="h-full px-4 pt-2">
	      <h2 class="text-sm font-bold">
	      {{ selected_plan.title }}
	      </h2>
	      <a class="underline" target="_blank" :href="selected_plan.file_url" v-if="selected_plan.file_url">
		      <!-- External icon -->
		      <svg class="w-4 h-4 inline-flex" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="#282828" fill-rule="evenodd" d="M14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4L21 10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10L19 6.41422L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L17.5858 5H14ZM3 7C3 5.89543 3.89543 5 5 5H10C10.5523 5 11 5.44772 11 6C11 6.55228 10.5523 7 10 7H5V19H17V14C17 13.4477 17.4477 13 18 13C18.5523 13 19 13.4477 19 14V19C19 20.1046 18.1046 21 17 21H5C3.89543 21 3 20.1046 3 19V7Z" clip-rule="evenodd"/></svg>
		Open in a new tab
	      </a>
	      <hr class="my-2"/>
	      <!-- Embed PDF File -->
	      <embed :src="selected_plan.file_url" type="application/pdf" width="100%" height="100%"/>
      </div>
      <div class="text-gray-600 flex justify-center items-center h-full"
           v-if="selected_plan == null && !isLoading">
        <div class="text-center">
            <span v-if="isGuest">
              No shooting plan published <br/> by the host
            </span>
            <span v-else>
              No shooting plan selected
            </span>
        </div>
      </div>
      <div class="text-gray-600 flex justify-center items-center h-full" v-if="isLoading">
        <div class="text-center">
          <div class="loader mx-auto mb-2"></div>
          Loading...
        </div>
      </div>
    </div>
    <modal :showModal="showLightbox" @close="closeLightbox()" classSize="lg:max-w-4xl">
      <div class="pt-4 md:pt-2">
        <div class="hidden md:block text-center bg-yellow-200 rounded-md text-yellow-700 px-2 py-2 mb-2">
        To speak while keeping your eyes on this graphic, press and hold the space bar
        </div>
        <div class="relative">
		<!--pdf></pdf-->
        </div>
	<div class="mt-3 text-center sm:mt-5" v-if="selected_plan">
          <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
            {{ selected_plan.title }}
          </h3>
        </div>
      </div>
      <div class="mt-5 sm:mt-6 sm:grid sm:gap-3 sm:grid-flow-row-dense"
	   :class="{'sm:grid-cols-1': isGuest}">
        <button type="button" class="btn btn-secondary" @click="closeLightbox()">
          Close
        </button>
      </div>
    </modal>
    <!-- Upload Folder modal -->
    <modal :showModal="showUploadFolderModal" @close="showUploadFolderModal = false" class-size="sm:max-w-2xl">
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <!-- Folder add icon -->
        <svg class="h-6 w-6 fill-current text-green-600" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             fill="none" viewBox="0 0 24 24">
          <path fill-rule="evenodd"
                d="M2 6C2 4.89543 2.89543 4 4 4H9C9.26522 4 9.51957 4.10536 9.70711 4.29289L11.4142 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM8.58579 6L4 6V18H20V8H11C10.7348 8 10.4804 7.89464 10.2929 7.70711L8.58579 6ZM12 10C12.5523 10 13 10.4477 13 11V12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V14H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12H11V11C11 10.4477 11.4477 10 12 10Z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <div class="mt-3 text-center sm:mt-5">
        <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline-upload-folder">
        Select a shooting plan to upload
        </h3>
        <div class="mt-2">
		The plan must be in a PDF format
        </div>
      </div>
      <div class="flex justify-center" v-show="!formIsValid">
        <div class="w-48 px-4 mt-5 mx-auto">
          <input class="w-full" id="inputShootingPlan" type="file"
                 @change="filesChange($event.target.files)"
                 accept="application/pdf">
        </div>
      </div>
      <div class="flex justify-end mt-5 px-4" v-show="formIsValid">
        <button @click="resetUploadFolder(true)" class="btn btn-secondary">
        Change plan
        </button>
      </div>
      <div v-if="formIsValid">
        <input type="text" v-model="input_title" placeholder="Shooting plan" class="h-12 form-input">
      </div>

      <div class="mt-5 sm:mt-6 sm:grid sm:gap-3 sm:grid-flow-row-dense" :class="formIsValid ? 'sm:grid-cols-2': 'sm:grid-cols-1'">
        <button type="button" @click="uploadShootingPlan" :disabled="!formIsValid" class="btn sm:col-start-2 overflow-hidden sm:text-sm"
                :class="formIsValid ? 'btn-primary' : 'btn-disabled'"
                v-show="formIsValid">
          Upload
        </button>

        <button type="button" class="btn btn-secondary" @click="resetUploadFolder()">
          Cancel
        </button>
      </div>

    </modal>
  </div>
</template>
<script>
import axios from 'axios'
import messageBroker from 'general/messageBroker';
import { localNotify } from 'utils/notifications';
import { addTask } from 'utils/status-indicator';

import commandsManager from 'general/CommandsManager'

export default {
  props: ['isGuest'],
  data() {
    return {
      isLoading: false,
      showLightbox: false,
      roomActivated: false,
      shooting_plans: [],
      selected_plan: null,
      // upload modal variables
      showUploadFolderModal: false,
      fileSizeInvalid: false,
      fileLimitInMB: 4,
      formData: {
        type: FormData
      },
      input_title: null,
      filesData: [],
      uploadTask: {},
      processingCreateFolder: false,

      presentationMode: false
    }
  },
  computed: {
    formIsValid(){
      return !this.processingCreateFolder && this.filesData.length !== 0
    },
  },
  mounted() {
    this.loadShootingPlans();
    this.$root.$on('roomActivated', () => {
      this.roomActivated = true;
      // only reset folder id if the selected_board is not demo folder
      if (this.selected_plan && this.selected_plan.title == 'Demo folder'){
	this.selected_plan = null;
      }
    })

    // set commands
    commandsManager
      .registerNewCommand('set_shooting_plan', (data) =>{
	      this.selected_plan =  data.args.shooting_plan;
      })
      .registerNewCommand('show_shooting_plan', (data) => {
        this.showShootingPlan(data.args.shooting_plan);
      })
      .registerNewCommand('hide_shooting_plan', () => {
        this.hideShootingBoard();
      })
  },
  methods: {
	  changedShootingPlan(){
		  if(this.selected_plan == -1){
			  this.showUploadFolderModal = true;
		  }
      		commandsManager.sendAllCommand('set_shooting_plan', { shooting_plan: this.selected_plan } );
	  },

    loadShootingPlans() {
      axios.get('/shooting_plans').then(response => {
        this.shooting_plans = response.data;
        this.shooting_plans.forEach(sp => {
          if (sp.title == 'Demo folder' && !this.roomActivated) {
              this.selected_plan = sp;
          }
        });
      });
    },
    _renderFrameLightbox(shooting_frame) {
      this.showLightbox = true;
      this.selected_frame = shooting_frame;
    },
    filterFiles(files){
      const filteredFiles = ['.DS_Store']
      const allowedType = 'pdf'
      return [...files].filter(file => file.type.includes('pdf'))
    },
    filesChange(fileList) {
      this.formData = new FormData();
      this.filesData = [];
      this.input_title = null;
      const filteredFileList = this.filterFiles(fileList);
      if (filteredFileList.length == 0) return
      this.formData.append('shooting_plan[file]', filteredFileList[0], filteredFileList[0].name);
      this.filesData.push(filteredFileList[0]);
      this.input_title = filteredFileList[0].name.split('.')[0];

      this.filesData.forEach((x, i) => {
        let reader = new FileReader();
        reader.onload = function (e) {
          // get loaded data and render thumbnail.
		// Disabling folder
          // document.getElementById("shootingBoardFrameUploaded_" + i).src = e.target.result;
        };
        // read the image file as a data URL.
        reader.readAsDataURL(x);
      })
    },
    uploadShootingPlan() {
      this.uploadTask = addTask({id: 'UPLOAD_SHOOTING_PLAN',
        determinate: true,
        message: 'Uploading shooting plan...'
      })
      this.processingCreateFolder = true
      let url = '/shooting_plans/upload'
      //let formData = new FormData();
      this.formData.append('authenticity_token', authenticity_token);
      this.formData.append('shooting_plan[title]', this.input_title);

      axios.post(url, this.formData, {
        onUploadProgress: progressEvent => {
          if (progressEvent.lengthComputable) {
            this.uploadTask.update(parseInt(progressEvent.loaded / progressEvent.total, 10) * 100);
          }
          if ((progressEvent.loaded / progressEvent.total) === 1) {
            // finished upload
          }
        }
      }).then(response => {
        this.showUploadFolderModal = false;
        this.loadShootingPlans()
        this.processingCreateFolder = false
        this.uploadTask.done();

        this.resetUploadFolder();
      }).catch(err => {
	      console.log(err)
        this.uploadTask.error();
        this.processingCreateFolder = false
      });
    },
     resetUploadFolder(showModal = false){
       this.showUploadFolderModal = showModal;
       this.selected_plan = null;
       this.formData = new FormData();
       this.filesData = [];
    },
    sendShootingPlan(peerId) {
	messageBroker.sendCommand('set_shooting_plan', peerId, {shooting_plan: this.selected_plan})
    },
    // not used yet
    presentShootingPlan(){
      this.presentationMode = true;
      commandsManager.sendAllCommand('show_shooting_plan', { shooting_plan: this.selected_plan } );
    },
    // not used yet
    closeLightbox(){
      if(this.presentationMode == true){
        commandsManager.sendAllCommand('hide_shooting_plan');
      }
      this.showLightbox = false;
      this.presentationMode = false;
    },
    showShootingPlan(shooting_plan){
      this._renderFrameLightbox(shooting_plan);
    },
    hideShootingBoard(){
      this.showLightbox = false;
    },
  }
}
</script>
<style lang="scss">
</style>
